// import components for pmgc achievements

import Index from './index'

export default [
  {
    path: '/achievements',
    name: 'PMGC Achievements',
    component: Index
  }
]



// WEBPACK FOOTER //
// ./src/pmgc/achievements/router.js